import React from 'react';
import GoalServices from '../../../../services/goal.services';
import { autoResizeTextArea, reactLoader, removeReactLoader } from '../../../../utils/common';
import { isNumberWithComma, UcfirstChar, uniqueArrayObject } from '../../../../utils/function';
import * as MetricFunc from '../../../../utils/metric';
import { TypeFaceText } from "../../../inputs/buttons.component";
import { ErrorTextComp, TextareaFieldComp } from "../../../inputs/fields.component";
import SearchBoxComp from '../../../inputs/searchbox.component';
import { CascadeResultsHeaderTableComp, CascadeResultsTableComp, PeopleSearchBoxList, RollUpKrSearchTableComp, RollUpTableComp, UserRoundPictureComp } from "./rolluptable.component";
import TeamServices from "../../../../services/team.services";
import DropdownComp from '../../../../components/dropdown/dropdown';
import HelpTextComp from '../../../helper/helptext.component';
import { RadioGroup, Radio, Dropdown } from '@workboard/wobo-ui';
import styled from 'styled-components';
const CASCADE_KR_TYPE = 'cascade_kr';
// import { withTranslation } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const StyledDropdown = styled(Dropdown)`
    .MuiSelect-root {
        background-color: #f2f2f2 !important;
        border: 1px solid rgba(0,0,0,0.06);
    }
`
export default class ContributeKrComp extends React.Component {

    constructor(props) {
        super(props);
        const { t } = this.props;
        let { cascadeMetric, currentUser } = this.props.data;
        this.getNewState = this.getNewState.bind(this);
        this.state = this.getNewState(cascadeMetric, currentUser, t);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.changeCascadeKrType = this.changeCascadeKrType.bind(this);
        this.changeMetricName = this.changeMetricName.bind(this);
        this.changeInitialValue = this.changeInitialValue.bind(this);
        this.changeTargetValue = this.changeTargetValue.bind(this);
        this.changeLowerValue = this.changeLowerValue.bind(this);
        this.changeUpperValue = this.changeUpperValue.bind(this);
        this.renderSearchKR = this.renderSearchKR.bind(this);
        this.clickKrItem = this.clickKrItem.bind(this);
        this.removeKr = this.removeKr.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.changeMessageText = this.changeMessageText.bind(this);
        this.changeTextBox = this.changeTextBox.bind(this);
        this.clickPeople = this.clickPeople.bind(this);
        this.renderPeopleSearchResults = this.renderPeopleSearchResults.bind(this);
        this.renderSelectedText = this.renderSelectedText.bind(this);
        this.sendUserNotification = this.sendUserNotification.bind(this);
        this.filterPeopleList = this.filterPeopleList.bind(this);
        this.triggerSave = this.triggerSave.bind(this);
        this.checkPeopleValue = this.checkPeopleValue.bind(this);
        this.renderSingleSelectPeopleList = this.renderSingleSelectPeopleList.bind(this);
        this.GoalServices = new GoalServices();
        this.teamUserCollections = {};
        this.TeamServices = new TeamServices();
        this.getKrTypeOptions = (type = '') => {

            const krTypeOptions = [
                {
                    id: 'self_kr',
                    label: t('I will make key result updates.'),
                    value: 1
                },
                {
                    id: 'delegate_kr',
                    label: t('Delegate someone else to make updates'),
                    value: 2
                },
                {
                    id: 'people_kr',
                    label: t('Cascade this key result again to multiple people'),
                    value: 3
                },
                {
                    id: 'linked_kr',
                    label: t('Link to another key result for updates'),
                    value: 4
                }
            ];

            if (type == 1) {
                return krTypeOptions.filter(f => (f.value != 4));
            }
            return krTypeOptions;
        };
        this.sendRequest = false;
        this.changeProgressType = this.changeProgressType.bind(this);
        this.changeProgressCascadeType = this.changeProgressCascadeType.bind(this);
    }

    componentDidUpdate (prevProps, _) {
        // if prev props and current props are different
        if(this.props === prevProps) return;
        const { t } = this.props;
        let { cascadeMetric, currentUser } = this.props.data;
        this.setState(this.getNewState(cascadeMetric, currentUser, t));
    }

    getNewState(cascadeMetric, currentUser, t) {
        let cascadeKrType = '';
        this.defaultOwner = currentUser;
        let source_cascade_owner = currentUser.userId || "";
        if (parseInt(cascadeMetric.ca_req_status) != 1) {
            if (cascadeMetric.source == 1) {
                this.defaultOwner = cascadeMetric.metricPeople;
                cascadeKrType = currentUser.userId == cascadeMetric.owner ? 1 : 2;
                source_cascade_owner = cascadeMetric.owner;
            }
            else if (cascadeMetric.source == 3) {
                cascadeKrType = 3;
            }
            if (cascadeMetric.source == 11) {
                cascadeKrType = 4;
            }
        }
        const stateMessage = cascadeMetric.message || `${t('I am cascading you this key result from my objective so that you can track it.')} ${t('You can either pick it up and make updates yourself, delegate someone else to make updates, recascade the key result to others, or link to an existing key result')}.`;
        return {
            cascadeKrType,
            krText: cascadeMetric.name || '',
            target: cascadeMetric.target || '',
            initial_data: cascadeMetric.initial_data || 0,
            message: stateMessage,
            metricMirror: cascadeMetric.metricMirror || [],
            metricCascdeUserList: cascadeMetric.metricCascdeUserList || [],
            source_cascade_owner,
            errors: {},
            checkedValues: [],
            measureMetricData: (cascadeMetric.progress_type == 3) ? 5 : cascadeMetric.measure_metric_data,
            progressType: cascadeMetric.progress_type == 3 ? 1 : cascadeMetric.progress_type,
            upper_limit: cascadeMetric.upper_limit || '',
            lower_limit: cascadeMetric.lower_limit || '',
            counting: cascadeMetric.counting,
            legacyData: cascadeMetric.legacyData || 0,
            progressTypeOrginial: cascadeMetric.progress_type,
        }

    }

    renderSingleSelectPeopleList(values, searchboxInst) {
        if (values.length) {
            $(".kr-modal-content").animate({ scrollTop: 550 });
            return values.map(v => <PeopleSearchBoxList key={v.type + '_' + v.userId + '_' + v.teamId} attr={{ rowClick: this.clickPeople }} row={v} inst={searchboxInst} />);
        }
        else {
            return null;
        }
    }

    renderPeopleSearchResults(values, searchboxInst) {
        if (values.length) {
            $(".kr-modal-content").animate({ scrollTop: 550 });
            let attr = {};
            attr.checkedValues = this.state.checkedValues;
            attr.checkBoxProps = {
                onChange: this.checkPeopleValue
            };
            return values.map(v => (
                <PeopleSearchBoxList
                    key={v.type + "_" + v.userId + "_" + v.teamId}
                    row={v}
                    inst={searchboxInst}
                    attr={attr}
                />
            ));
        } else {
            return null;
        }
    }

    constructTeamMemberUsers(users = []) {
        return users.map(u => ({
            firstname: u.name,
            lastname: u.lastName,
            fullName: `${u.name} ${u.lastName}`,
            req_uid: u.id,
            target: '',
            isNew: true,
            teamId: u.team_id
        }));
    }
    checkPeopleValue(e, item, searchBoxInst) {
        if (item) {
            let _this = this;
            let { metricCascdeUserList, checkedValues, errors } = this.state;
            let chk = e.target.checked;
            let itemId =
                item.type + "_" + (item.type == "2" ? item.teamId : item.userId);
            if (chk) {
                checkedValues = [...checkedValues, itemId];
                if (item.type == "2") {
                    if (typeof this.teamUserCollections[item.teamId] == "undefined") {
                        this.TeamServices.getTeamUserDetails({
                            teamId: item.teamId,
                            allUser: 1
                        }).then(response => {
                            if (response.data) {
                                _this.teamUserCollections[item.teamId] = _this.constructTeamMemberUsers(response.data.inviteeList || []);
                                if (typeof this.teamUserCollections[item.teamId] != "undefined") {
                                    let uniqueUsers = uniqueArrayObject([
                                        ...metricCascdeUserList,
                                        ..._this.teamUserCollections[item.teamId]
                                    ], 'req_uid');
                                    metricCascdeUserList = uniqueUsers;
                                    //console.log(metricCascdeUserList,"metricCascdeUserList");
                                    _this.setState({ metricCascdeUserList, checkedValues });
                                }
                            }
                        });
                    } else {
                        if (typeof this.teamUserCollections[item.teamId] != "undefined") {
                            let uniqueUsers = uniqueArrayObject([
                                ...metricCascdeUserList,
                                ..._this.teamUserCollections[item.teamId]
                            ], 'req_uid');
                            metricCascdeUserList = uniqueUsers;
                            _this.setState({ metricCascdeUserList, checkedValues });
                        }
                    }
                } else {
                    let findUser = metricCascdeUserList.find(
                        u => u.req_uid == item.userId
                    );
                    if (!findUser) {
                        let fullName = typeof item.fullName !== 'undefined' ? item.fullName : `${item.firstName} ${item.lastName}`;
                        metricCascdeUserList = [
                            ...metricCascdeUserList,
                            {
                                firstname: item.firstName,
                                lastname: item.lastName,
                                fullName: fullName,
                                req_uid: item.userId,
                                target: '',
                                isNew: true
                            }
                        ];
                    }
                }
            } else {
                if (item.type == "1") {
                    metricCascdeUserList = metricCascdeUserList.filter(
                        u => !(u.req_uid == item.userId && typeof u.isNew != 'undefined' && u.isNew == true)
                    );
                } else if (item.type == "2") {
                    if (typeof this.teamUserCollections[item.teamId] != "undefined") {
                        metricCascdeUserList = metricCascdeUserList.filter(
                            u => typeof u.teamId == "undefined" || u.teamId != u.teamId
                        );
                    }
                }
                checkedValues = checkedValues.filter(v => v != itemId);
            }
            if (typeof errors['select_people'] !== 'undefined') {
                delete errors['select_people'];
            }
            this.setState({
                metricCascdeUserList,
                checkedValues,
                errors
            });
        }
    }

    sendUserNotification(item) {
        const { t } = this.props
        this.GoalServices.sendCascdePingNotification({metricId: item.pkr_id,
            reqUserID: item.req_uid}).then((response) => {
            if (response.data) {
                infoPopup.call(item.firstname + ' ' + t('will get a notification and an email asking for an update'));
            }
        });
    }

    renderSelectedText(item) {
        let pic = item.picture;
        let fullName = item.fullName ? item.fullName : item.firstname + " " + item.lastname;
        let picKey = (typeof item.userId !== 'undefined') ? item.userId : ((typeof item.uid !== 'undefined') ? item.uid : '');
        picKey = picKey ? "user_pic_" + picKey : pic;
        return (
            <div>
                <UserRoundPictureComp className="left" key={picKey} pic={pic} />
                <div className="truncate left" style={{ lineHeight: "32px" }}>{fullName}</div>
                <div className="clear"></div>
            </div>
        )
    }

    clickPeople(e, item, searchboxInst) {
        if (item) {
            $(e.target).trigger("mouseleave");
            if (this.state.cascadeKrType == 2) {
                this.setState({
                    source_cascade_owner: item.userId
                }, () => {
                    if (searchboxInst) {
                        searchboxInst.updateSelectedItem(item);
                        searchboxInst.closeBox();
                    }
                });
            }
            else {
                let { errors, metricCascdeUserList } = this.state;
                let findUser = metricCascdeUserList.find(u => u.req_uid == item.userId);
                if (!findUser) {
                    let firstname = item.firstName;
                    let lastname = item.lastName;
                    let fullName = item.fullName ? item.fullName : firstname + ' ' + lastname;
                    let newUser = { firstname, lastname, fullName, req_uid: item.userId, target: '', isNew: true };
                    metricCascdeUserList = [...metricCascdeUserList, newUser];
                }
                let updateData = { metricCascdeUserList };
                if (typeof errors['select_people'] !== 'undefined') {
                    delete errors['select_people'];
                    updateData.errors = errors;
                }
                //console.log('updateData', updateData);
                this.setState(updateData, () => {
                    if (searchboxInst) {
                        searchboxInst.closeBox();
                    }
                });
            }
        }
    }

    changeTextBox(e, item) {
        var v = e.target.value.trim();
        let metricObj = this.state;
        let metricCascdeUserList = metricObj.metricCascdeUserList.map(u => {
            if (u.req_uid == item.req_uid) {
                u.target = ((v && isNumberWithComma(v)) || v == '') ? v : u.target;
            }
            return u;
        })
        this.setState({ metricCascdeUserList });
    }

    changeMessageText(e) {
        autoResizeTextArea(document.getElementById('message'));
        this.setState({ message: e.target.value });
    }

    changeInitialValue(e) {
        var v = e.target.value.trim();
        let errors = this.state.errors;
        let val = ((v && isNumberWithComma(v)) || v == '') ? v : this.state.initial_data;
        if (typeof errors['initial_data'] !== 'undefined') {
            delete errors['initial_data'];
        }
        this.setState({ initial_data: val, errors });
    }

    changeTargetValue(e) {
        var v = e.target.value.trim();
        let errors = this.state.errors;
        let val = ((v && isNumberWithComma(v)) || v == '') ? v : this.state.target;
        if (typeof errors['target'] !== 'undefined') {
            delete errors['target'];
        }
        this.setState({ target: val, errors });
    }

    changeLowerValue(e) {
        var v = e.target.value.trim();
        let errors = this.state.errors;
        let val = ((v && isNumberWithComma(v)) || v == '') ? v : this.state.lower_limit;
        if (typeof errors['lower_limit'] !== 'undefined') {
            delete errors['lower_limit'];
        }
        this.setState({ lower_limit: val, errors });
    }

    changeUpperValue(e) {
        var v = e.target.value.trim();
        let errors = this.state.errors;
        let val = ((v && isNumberWithComma(v)) || v == '') ? v : this.state.upper_limit;
        if (typeof errors['upper_limit'] !== 'undefined') {
            delete errors['upper_limit'];
        }
        this.setState({ upper_limit: val, errors });
    }

    getErrorClass(field) {
        return (typeof this.state.errors[field] !== 'undefined') ? ' errorBorder  ' : '';
    }

    changeCascadeKrType(item) {
        if (item.value != this.state.cascadeKrType) {
            let mmData = 1;
            let pType = this.state.progressType;
            if (item.value == 3) {
                mmData = 5;
                pType = 1;
            }
            this.setState({ cascadeKrType: item.value, measureMetricData: mmData, progressType: pType, errors: {} });
        }
    }

    changeMetricName(e) {
        autoResizeTextArea(document.getElementById("metric-name-text"));
        let errors = this.state.errors;
        if (typeof errors['krText'] !== 'undefined') {
            delete errors['krText'];
        }
        this.setState({ krText: e.target.value, errors });
    }

    changeProgressType(e, item) {
        this.setState({ measureMetricData: item.value });
    }

    changeProgressCascadeType(e, item) {
        this.setState({ progressType: e.target.value });
    }

    renderSearchKR(values = [], inst) {
        if (values.length) {
            let attr = {};
            attr.rowClick = this.clickKrItem;
            return values.map(m => (
                <RollUpKrSearchTableComp key={"render_search_" + m.id} value={m} attr={attr} inst={inst} />
            ));
        } else {
            return null;
        }
    }

    clickKrItem(e, item, searchboxInstance) {
        //$(e.target).trigger("mouseleave");
        //console.log('e.target', e.target);
        $(e.target).trigger("mouseleave");
        if (searchboxInstance) {
            searchboxInstance.closeBox();
        }
        let errors = this.state.errors;
        if (typeof errors['mirror_kr'] !== 'undefined') {
            delete errors['mirror_kr'];
        }
        this.setState({ metricMirror: [item], errors });
    }

    removeKr(e, item) {
        this.setState({ metricMirror: [] });
    }

    removeItem(e, item) {
        if (item) {
            let metricCascdeUserList = this.state.metricCascdeUserList.filter(u => u.req_uid != item.req_uid);
            let checkedValues = this.state.checkedValues.filter(
                u => u != `1_${item.req_uid}`
            );
            this.setState({ metricCascdeUserList, checkedValues });
        }
    }
    renderError(field) {
        return <ErrorTextComp errors={this.state.errors} field={field} />;
    }

    triggerSave() {
        //console.log('triggerSave');
        if (this.sendRequest) {
            return;
        }
        const { t } = this.props;
        let errors = {};
        let { cascadeKrType, krText, target, metricMirror, metricCascdeUserList, initial_data, lower_limit, upper_limit, counting } = this.state;
        if (cascadeKrType == '') {
            errors['cascadeKrType'] = target(t('Choose how you want to make updates'));
        }
        if (cascadeKrType != 4) {
            if (krText == '') {
                errors['krText'] = t('Enter key result summary');
            }
            //console.log('initial_data--------------------',initial_data);
            if (initial_data == '' && initial_data != 0) {
                errors['initial_data'] = t('Enter value');
            }
            if (counting != 4) {
                if (target == '') {
                    errors['target'] = t('Enter value');
                }
            }
            if (cascadeKrType == 3) {
                if (!metricCascdeUserList.length) {
                    errors['select_people'] = t('Search and select a person(s)');
                }
            }

            if (counting == 1 &&
                isNumberWithComma(target) &&
                isNumberWithComma(initial_data) &&
                parseFloat(initial_data) > parseFloat(target)
            ) {
                errors["initial_data"] =
                    t("Start value should be less than target.");
            }

            if ((cascadeKrType == 1 || cascadeKrType == 2) && counting == 2 &&
                isNumberWithComma(target) &&
                isNumberWithComma(initial_data) &&
                parseFloat(initial_data) < parseFloat(target)
            ) {
                errors["initial_data"] =
                    t("Start value should be greater than target.");
            }


            if (counting == 4) {
                if (lower_limit == '') {
                    errors['lower_limit'] = t('Enter value');
                }
                else if (lower_limit && !isNumberWithComma(lower_limit)) {
                    errors['lower_limit'] = t('Enter numeric value');
                }
                if (upper_limit == '') {
                    errors['upper_limit'] = t('Enter value');
                }
                else if (upper_limit && !isNumberWithComma(upper_limit)) {
                    errors['upper_limit'] = t('Enter numeric value');
                }
                if (
                    isNumberWithComma(lower_limit) &&
                    isNumberWithComma(upper_limit) &&
                    parseFloat(upper_limit) < parseFloat(lower_limit)
                ) {
                    errors["lower_limit"] =
                        t("Lower limit value should be less than Upper limit value");
                }
            }
        }
        else {
            if (!metricMirror.length) {
                errors['mirror_kr'] = t('Select a key result');
            }
        }

        if (Object.keys(errors).length) {
            this.setState({ errors });
        }
        else {
            let { cascadeMetric, currentUser } = this.props.data;
            let params = {};
            params.name = krText;
            params.goal_id = null;
            params.source = 9;
            params.counting = cascadeMetric.counting;
            if (params.counting == 4) {
                params.counting = 4;
                params.upper_limit = this.state.upper_limit;
                params.lower_limit = this.state.lower_limit;
            }
            else {
                params.upper_limit = cascadeMetric.upper_limit || '';
                params.lower_limit = cascadeMetric.lower_limit || '';
            }
            params.interval = cascadeMetric.interval;
            params.weekly_update_day = cascadeMetric.weekly_update_day;
            params.progress_type = this.state.progressType == 3 ? 1 : this.state.progressType;
            params.message = this.state.message;
            params.parentMetId = cascadeMetric.id;
            params.initial_data = this.state.initial_data;//cascadeMetric.initial_data;
            params.metric = cascadeMetric.metric;
            if (parseInt(cascadeMetric.ca_req_status) != 1) {
                params.id = cascadeMetric.id;
            }
            if (typeof cascadeMetric.cascade_goal_id !== 'undefined' && cascadeMetric.cascade_goal_id !== null) {
                params.cascade_goal_id = cascadeMetric.cascade_goal_id;
                params.cascade_source_type = 1;
            }
            else {
                params.cascade_goal_id = cascadeMetric.goal_id;
            }
            params.permission = cascadeMetric.permission;
            params.createMetricUserId = currentUser.userId;
            params.source_cascade_owner = this.state.source_cascade_owner;
            //params.permission_teams = [];
            if (cascadeKrType == 1 || cascadeKrType == 2) {
                params.target = target;
                params.cascade_source_type = 1;
                params.source_cascade_owner = (cascadeKrType == 1) ? currentUser.userId : this.state.source_cascade_owner;
            }
            else if (cascadeKrType == 3) {
                params.metricCascade = [];
                params.metricCascadeWithTarget = {};
                metricCascdeUserList.map(u => {
                    params.metricCascade.push(u.req_uid);
                    params.metricCascadeWithTarget[u.req_uid] = u.target;
                });
                params.target = target;
                params.cascade_source_type = 2;
            }
            else if (cascadeKrType == 4) {
                params.cascade_source_type = 1;
                params.mirror_kr_id = metricMirror.map(k => k.id).join("");
            }
            params.measure_metric_data = this.state.measureMetricData;
            let _this = this;
            //console.log('params', params);
            this.sendRequest = true;
            reactLoader(true);
            this.GoalServices.addEditKr({ goalId: null, metric: params }).then(
                response => {
                    _this.sendRequest = false;
                    removeReactLoader();
                    if (response.data) {
                        let { cascade_goal_id } = response.data.data;
                        _this.props.handleCloseModal();
                        if ($('#goal_index_page').length) {
                            if (typeof window.MyGoalContainer !== 'undefined') {
                                window.MyGoalContainer.updateGoalItems({ action: 'createCascade', goalId: cascade_goal_id, metricId: params.parentMetId });
                            }
                        }
                        triggerNotificationTry();
                        window.dispatchEvent(new CustomEvent('krDataRefresh'));
                    }
                }
            ).catch(error => {
                _this.sendRequest = false;
                removeReactLoader();
                if(this.props.onError) {
                    this.props.onError(error);
                }
            });
        }
    }
    filterPeopleList(values = []) {
        if (Array.isArray(values) && values.length) {
            values = values.filter(u => u.type == 1);
        }
        return values;
    }

    render() {
        const { t } = this.props;
        let { cascadeMetric } = this.props.data;
        let item = cascadeMetric || {};
        let cascadeKrType = this.state.cascadeKrType;
        let isError = Object.keys(this.state.errors).length;
        let rows = this.state.metricMirror;
        let metricCascdeUserListRows = this.state.metricCascdeUserList;
        //console.log(metricCascdeUserListRows,"metricCascdeUserListRows");
        let existingRows = metricCascdeUserListRows.filter(u => typeof u['id'] !== 'undefined');
        let newRows = metricCascdeUserListRows.filter(u => typeof u['isNew'] !== 'undefined');
        let realOwner = this.props.showRealOwner ? this.props.showRealOwner : false;
        //console.log(newRows,"newRows");
        let peopleLabel = t('Find person(s) to cascade to');
        if (existingRows.length) {
            peopleLabel = t('Find additional person(s) to cascade to');
        }
        //console.log('item', item);
        let measureInfo = {
            interval: item.originalKR.interval,
            metricText: MetricFunc.getMetricTypeText(item.originalKR.metric),
            intervalText: MetricFunc.getIntervalText(item.originalKR.interval),
            initial_data: item.originalKR.initial_data,
            countingText: MetricFunc.getCountingText(item.originalKR.counting),
            weekDay: MetricFunc.getWeekDay(item.originalKR.weekly_update_day),
            target: item.originalKR.target
        };
        // console.log('cascadeKrType', cascadeKrType);
        let textareaLabel = t('What is the result you want to measure?');
        let textareaProps = {
            id: "metric-name-text",
            "data-testid":"metric-name-text",
            name: "metric",
            onChange: this.changeMetricName,
            value: this.state.krText
        };
        let labelRightSide = '';
        if (wbConfig.default_org_locale == 'locale_1') {
            labelRightSide = `<a class="sample-okr-text" href="https://www.workboard.com/okrs-by-function/" target="_blank">${t('See sample OKRs')}</a>`;
        }
        let CountValue = cascadeMetric.counting;
        let metricValue = cascadeMetric.metric;
        let gStart = cascadeMetric.gStart;
        let gEnd = cascadeMetric.gEnd;
        //console.log(cascadeMetric);
        const items = this.getKrTypeOptions(this.state.legacyData)
        const progressTypeOptions = MetricFunc.getProgressTypeCascadeOptions()
        const progressTypeConv = Number(this.state.progressType)

        return (
            <div className="contribute-kr-comp-wrapper">
                <CascadeInfo {...item} />
                <div className="line3"></div>
                <div className="fieldcontent">
                    <div className="make_updates_button_wrapper">
                        <RadioGroup
                            label={realOwner ? t('As the owner of the key result, how do you want to make updates?') : t("How do you want to make updates?")}
                            value={this.state.cascadeKrType}
                            defaultValue={this.state.cascadeKrType}
                            >
                                {
                                    items.length && items.map(i => (
                                        <Radio
                                            key={i.id}
                                            label={i.label}
                                            value={i.value}
                                            isChecked={this.state.cascaseKrType === i.value}
                                            onChange={() => this.changeCascadeKrType(i)}
                                        />
                                    ))
                                }
                        </RadioGroup>
                    </div>

                    {isError ? this.renderError('cascadeKrType') : ''}
                    {
                        (cascadeKrType != '') ?
                            <div>
                                {
                                    (cascadeKrType != 4) ?
                                        <div>
                                            <div className="fieldcontent">
                                                <div className="labeltext-27px">{t('PRIMARY KEY RESULT')}</div>
                                            </div>
                                            <div className="fieldcontent">
                                                <TextareaFieldComp
                                                    label={textareaLabel}
                                                    labelRightSide={labelRightSide}
                                                    InputTypeFaceText="true"
                                                    labelClass="metric-label-text"
                                                    textareaProps={textareaProps}
                                                />
                                                {isError ? this.renderError('krText') : ''}
                                            </div>
                                        </div>
                                        : ''
                                }
                                <CascadeMeasureInfo {...measureInfo} />

                                {
                                    (cascadeKrType != 4) ?
                                        <div className="fieldcontent" style={{ minHeight: '75px' }}>
                                            {
                                                (cascadeKrType != 4 && cascadeKrType != 3) ?
                                                    <div className="left" style={{ width: "94px" }}>
                                                        <div className="labeltext-25px" id="label-starting_from">
                                                            {t('Starting from')}<TypeFaceText key="typeface" />
                                                        </div>
                                                        <div className="">
                                                            <input
                                                                type="text"
                                                                data-testid="starting-from"
                                                                className={"input-text " + (isError ? this.getErrorClass('initial_data') : '')}
                                                                value={this.state.initial_data}
                                                                onChange={e => this.changeInitialValue(e)}
                                                                autoComplete="off"
                                                                aria-labelledby='label-starting_from'
                                                            />
                                                        </div>
                                                        {isError ? this.renderError("initial_data") : ""}
                                                    </div> : ''
                                            }
                                            {
                                                CountValue != 4 ?
                                                    <div className="left" style={{ width: "94px" }}>
                                                        <div className="labeltext-25px" id="label-target_value">
                                                            {t('Target value')}<TypeFaceText key="typeface" />
                                                        </div>
                                                        <div className=" ">
                                                            <input
                                                                type="text"
                                                                data-testid='Target-value'
                                                                className={"input-text  " + (isError ? this.getErrorClass('target') : '')}
                                                                value={this.state.target}
                                                                onChange={e => this.changeTargetValue(e)}
                                                                autoComplete="off"
                                                                aria-labelledby="label-target_value"
                                                            />
                                                        </div>
                                                        {isError ? this.renderError("target") : ""}
                                                    </div>
                                                    : ''
                                            }
                                            {
                                                CountValue == 4 ?
                                                    <div>
                                                        <div className="left" style={{ width: "94px" }}>
                                                            <div className="labeltext-25px">
                                                                {t('Lower limit')}<TypeFaceText key="typeface" />
                                                            </div>
                                                            <div>
                                                                <input type="text" name="lower_limit" id="lower_limit" className={"input-text " + (isError ? this.getErrorClass('lower_limit') : '')}
                                                                    value={this.state.lower_limit}
                                                                    onChange={e => this.changeLowerValue(e)}
                                                                    autoComplete="nope"
                                                                />
                                                            </div>
                                                            {isError ? this.renderError('lower_limit') : ''}
                                                        </div>
                                                        <div className="left" style={{ width: "144px" }}>
                                                            <div className="labeltext-25px">
                                                                {t('Upper limit')}<TypeFaceText key="typeface" />
                                                            </div>
                                                            <div>
                                                                <input type="text" name="upper_limit" id="upper_limit" className={"input-text " + (isError ? this.getErrorClass('upper_limit') : '')}
                                                                    value={this.state.upper_limit}
                                                                    onChange={e => this.changeUpperValue(e)}
                                                                    autoComplete="nope"
                                                                />
                                                            </div>
                                                            {isError ? this.renderError('upper_limit') : ''}
                                                        </div>

                                                    </div>
                                                    : ''

                                            }

                                        </div>
                                        : ''
                                }

                                {
                                    (cascadeKrType == 1 || cascadeKrType == 2) ?
                                        <div className="fieldcontent" style={{ clear: 'both' }}>
                                            <div className="labeltext-25px" style={{ maxHeight: '10px' }}>
                                            {t('Calculate and graph progress for my key result as')} <HelpTextComp key="measurehelp" cascadeHelpTextPlace={true}>
                                                    <div>
                                                        <ul>
                                                            <li>
                                                                <b>{t('Last entered value')}: </b> {t('If a user entered "4" for the last update, the overall progress would also show 4.')}
                                                        </li>
                                                            <li>
                                                                <b>{t('[Total of all entered values]')}:</b> {t('If all updates over time are “2”, “3”, and“4”, the overall progress is “9”.')}
                                                        </li>
                                                        </ul>
                                                    </div>
                                                </HelpTextComp>
                                            </div>
                                            <div>
                                                <StyledDropdown
                                                    aria-label={`${t('Calculate and graph progress for my key result as')} `}
                                                    initialValue={this.state.progressType}
                                                    maxMenuHeight={290}
                                                    onChange={(e) => this.changeProgressCascadeType(e)}
                                                    optionTitleProp="name"
                                                    optionValueProp="value"
                                                    options={progressTypeOptions}
                                                    value={progressTypeConv}
                                                    size="medium"
                                                    width="255px"
                                                    MenuProps={{
                                                        style: {
                                                            zIndex: '1500000'
                                                        },
                                                    }}
                                                />
                                                <div className="clear"></div>
                                            </div>
                                        </div>
                                        : ''
                                }

                                <div className="line3" style={{ marginTop: "20px" }}></div>
                                {
                                    (cascadeKrType == 2) ?
                                        <div>
                                            <div className="fieldcontent">
                                                <div className="labeltext-27px">{t('DELEGATION SPECIFICATIONS')}</div>
                                            </div>
                                            <div className="fieldcontent">
                                                <SearchBoxComp
                                                    key="singlepeoplesearch"
                                                    minLength="2" wrapperClass="create-cascade-results-people"
                                                    dropdown={true}
                                                    defaultDropdownValue={this.defaultOwner}
                                                    renderSelectedText={this.renderSelectedText}
                                                    url={"goal/getTeamAndOrgUsersList?team=true"}
                                                    excludeAIAgents={true}
                                                    inputProps={{
                                                        placeholder: "Search for people",
                                                        className: (isError ? this.getErrorClass('select_people') : '')
                                                    }}
                                                    renderResultComp={this.renderSingleSelectPeopleList}
                                                    beforeFilterValues={this.filterPeopleList}
                                                />
                                            </div>
                                        </div>
                                        : ''
                                }
                                {
                                    (cascadeKrType == 3) ?
                                        <div>
                                            <div className="fieldcontent">
                                                <div className="labeltext-27px">{t('Cascades')}</div>
                                            </div>
                                            {
                                                (existingRows.length) ?
                                                    <div className="fieldcontent">
                                                        <div>
                                                            <CascadeResultsHeaderTableComp isNew={false} />
                                                        </div>
                                                        <div className="container-scroll">
                                                            {
                                                                existingRows.map(r => <CascadeResultsTableComp key={"cascade-" + r.req_uid} tableClass="rollup-cascade-table" row={r} removeItem={this.removeItem} sendUserNotification={this.sendUserNotification} changeTextBox={this.changeTextBox} />)
                                                            }
                                                        </div>
                                                    </div>
                                                    : ''
                                            }
                                            <div className="fieldcontent">
                                                <div className="labeltext-25px">
                                                    {peopleLabel}<TypeFaceText key="typeface" />
                                                </div>
                                                <div>
                                                    <SearchBoxComp
                                                        key="multipeople_team_search"
                                                        minLength="2"
                                                        wrapperClass="cascade-results-people"
                                                        url={"goal/getTeamAndOrgUsersList?team=true"}
                                                        excludeAIAgents={true}
                                                        inputProps={{
                                                            placeholder: t("Search for people or teams"),
                                                            className: (isError ? this.getErrorClass('select_people') : '')
                                                        }}
                                                        renderResultComp={this.renderPeopleSearchResults}
                                                    //beforeFilterValues={this.filterPeopleList}
                                                    />
                                                </div>
                                                {isError ? this.renderError('select_people') : ''}
                                            </div>
                                            {
                                                newRows.length ?
                                                    <div className="fieldcontent">
                                                        <div style={{ width: "415px" }}>
                                                            <CascadeResultsHeaderTableComp isNew={true} realOwner={realOwner} />
                                                        </div>
                                                        <div className="container-scroll" style={{ width: "415px" }}>
                                                            {
                                                                newRows.map(r => <CascadeResultsTableComp isNew={true} key={"cascade-" + r.req_uid} tableClass="rollup-cascade-table" row={r} removeItem={this.removeItem} changeTextBox={this.changeTextBox} />)
                                                            }
                                                        </div>
                                                    </div>
                                                    : ''
                                            }
                                            {
                                                metricCascdeUserListRows.length ?
                                                    <div className="fieldcontent">
                                                        <div>
                                                            <TextareaFieldComp label={realOwner ? t("Message owners will receive") +':' : t("Message assignees will receive")+ ':'} textareaProps={{ id: 'message', name: 'message', value: this.state.message ? this.state.message : '', onChange: this.changeMessageText }} />
                                                        </div>
                                                    </div>
                                                    : ''
                                            }
                                        </div>
                                        : ''
                                }

                                {
                                    (cascadeKrType == 3) ?
                                        <div className="fieldcontent" >
                                            <div className="labeltext-25px" style={{ maxHeight: '10px' }}>
                                            {t('Calculate and graph progress for my key result as')} <HelpTextComp key="measurehelp" cascadeHelpText={true}>
                                                    <div>
                                                        <ul>
                                                            <li>
                                                                <strong>{t('Total of achieved values')}:</strong> {t('If one assignee has an achieved value of "2", and another assignee has an achieved value of "3", the overall progress is "5".')}
                                                        </li>
                                                            <li>
                                                                <strong>{t('Average of achieved values')}:</strong> {`${t('If one assignee has an achieved value of "2", and another assignee has an achieved value of "3", the overall progress is')} "2.5".`}
                                                        </li>
                                                        </ul>
                                                    </div>
                                                </HelpTextComp>
                                            </div>
                                            <div>
                                                <DropdownComp
                                                    defaultValue={this.state.legacyData == 1 && this.state.progressTypeOrginial == 2 ? 1 : this.state.measureMetricData}
                                                    onChange={this.changeProgressType}
                                                    wrapperClass="add-okrs-dropdown-wrapper rollup-calculation-progress-dropdown"
                                                    options={MetricFunc.getCalculationCascadeProgressOption(this.state.legacyData == 1 && this.state.progressTypeOrginial == 2 ? "oldCascade" : "new")}
                                                    toShowRecascadeType={true}
                                                    appendId="contribute-kr-calc"
                                                />
                                                <div className="clear"></div>
                                            </div>
                                        </div>
                                        : ''
                                }

                                {
                                    (cascadeKrType == 4) ?
                                        <div>
                                            <div className="fieldcontent">
                                                <div className="labeltext-27px">{t('REFLECT EXISTING KEY RESULT SPECIFICATIONS')}</div>
                                            </div>
                                            <div className="fieldcontent">
                                                <div className="labeltext-25px">
                                                {t('Find an existing key result to link directly to')}
                                                <TypeFaceText />
                                                </div>
                                                <div className="">
                                                    <SearchBoxComp
                                                        minLength="2"
                                                        wrapperClass="linked-kr-box"
                                                        url={"goal/searchKrs?type=mirror_kr&as=" + metricValue + "&cascade=1&goal_start=" + gStart + "&goal_end=" + gEnd}
                                                        inputProps={{
                                                            placeholder: t("Search for key result, key result owner, or team"),
                                                            className: (isError ? this.getErrorClass('mirror_kr') : '')
                                                        }}
                                                        renderResultComp={this.renderSearchKR}
                                                        type={CASCADE_KR_TYPE}
                                                    />
                                                    {isError ? this.renderError("mirror_kr") : ""}
                                                </div>
                                                {
                                                    rows.length ? (
                                                        <div className="fieldcontent">
                                                            <div className="labeltext-25px">{t('Selected key result')}(s):</div>
                                                            <div className="width-600px">
                                                                {rows.map(r => (
                                                                    <RollUpTableComp
                                                                        key={"mirror_kr_" + r.id}
                                                                        type="kr"
                                                                        tableClass="rollup-kr-table"
                                                                        row={r}
                                                                        removeItem={this.removeKr}
                                                                    />
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ) : ("")
                                                }
                                            </div>
                                        </div>
                                        : ''
                                }
                            </div>
                            : ''
                    }

                </div>
            </div>
        )
    }
}

const CascadeInfo = (props) => {
    let firstname = UcfirstChar(props.firstname);
    let lastname = UcfirstChar(props.lastname);
    let originalMetricName = props.originalKR.name || '';
    let message = props.originalKR.message || "";
    const { t, i18n } = useTranslation();

    // if(typeof originalMetricName !== 'undefined' && originalMetricName !== null){
    //     originalMetricName = originalMetricName.length > 40 ? originalMetricName.substring(0, 40) + '...' : originalMetricName;
    // }
    return (
        <div className="cascade-info-wrapper width100">
            <div className="cascade-kr-info width100">
                <img className="fitProfileImage userpic-round-40px left" src={props.picture} alt="" />
                <div className="cascade-kr-header-line right">
                    {firstname + " " + lastname} {t('has cascaded a key result to you from their key result')}, <span className="blue-color-text">{originalMetricName}</span> {firstname}’s {t('message for you') +':'}
                </div>
                <div className="clear"></div>
            </div>
            <div className="cascade-kr-message">
                <div>{message}</div>
            </div>
        </div>
    )
}


const CascadeMeasureInfo = (props) => {
    let { metricText, intervalText, initial_data = 0, countingText, weekDay, interval, target } = props;
    initial_data = (initial_data == "" || initial_data == null) ? 0 : initial_data;
    let icon = 'icon-outline-arrow_upward-18px-blue';
    let imgName = '';
    let countingValue = countingText.value || 1;
    if (countingValue == 2) {
        icon = 'icon-outline-arrow_downward-18px-blue ';
    }
    else if (countingValue == 3) {
        icon = 'icon-exact-18px-blue';
    }
    else if (countingValue == 4) {
        icon = 'icon-outline-arrow_range-18px-blue';
    } else if (countingValue == 8) {
        imgName = 'exceed';
    } else if (countingValue == 9) {
        imgName = 'fallbelow';
    }
    const { t } = useTranslation();
    return (
        <div className="fieldcontent measure-info-details">
            <div className="measure-info-header">
                <div className="measure-unit">{t('Unit of measurement')}</div>
                <div className="measure-target">{t('Result value')} </div>
                <div className="mesaure-value">{t('Suggested target')}</div>
                <div className="measure-update">{t('Update')} </div>
            </div>
            <div className="measure-info-row">
                <div className="measure-unit" data-testid="measure-unit">{metricText}</div>
                <div className="measure-target" data-testid="measure-target">
                    { (countingValue == 8 || countingValue == 9) ?
                      <div className={"left"} style={{ marginTop: "2px", marginRight: "5px" }}><img src={`${wbConfig.imageCdnUrl}/images/goal/metric/${imgName}.png` } style={{width: '16px',height: '16px'}}/></div>
                    : <div className={"left icon " + icon} style={{ marginTop: "2px", marginRight: "5px" }}></div>}
                    <div className="left"  data-testid="result-value" style= {{ fontSize: `${countingValue == 9 ? '13px': '14px'}`}}>
                        {countingText.name}
                    </div>
                    <div className="clear"></div>
                </div>
                <div className="mesaure-value" data-testid="measure-value" style={{ whiteSpace: "pre-wrap" }}>{(target == '' || target === null) ? ' ' : target}</div>
                <div className="measure-update" data-testid="measure-update">{intervalText} {interval == 2 ? ' on ' + weekDay : ''} </div>
            </div>
            <div className="clear"></div>
        </div>
    )
}
